import React from "react";
import { Select } from "antd";

const { Option } = Select;

const countryCodes = ["FR", "BE", "DE", "GB", "IT", "ES", "NL"];

type CountryCodeSelectProps = {
  name: string;
  value?: string;
  onSelect: (value: string) => void;
};
const CountryCodeSelect: React.FC<CountryCodeSelectProps> = ({
  name,
  value,
  onSelect,
}) => {
  return (
    <Select
      id={name}
      value={value}
      placeholder="Select a country code"
      allowClear
      onChange={onSelect}
    >
      {countryCodes.map((code) => (
        <Option key={code} value={code}>
          {code}
        </Option>
      ))}
    </Select>
  );
};

export default CountryCodeSelect;
